import type { TooltipProps } from "@shopify/polaris"
import { Button, Tooltip } from "@shopify/polaris"
import { InfoIcon } from "polaris-enhance"

interface Iprops {
  jumpUrl: string
  content: string
  activatorWrapper?: TooltipProps["activatorWrapper"]
}

export default function TooltipByIcon(props: Iprops) {
  const { jumpUrl, content, activatorWrapper } = props
  return (
    <Tooltip content={content} activatorWrapper={activatorWrapper}>
      <Button
        variant="plain"
        icon={InfoIcon}
        size="micro"
        onClick={() => {
          window.open(jumpUrl, "_blank")
        }}
      />
    </Tooltip>
  )
}
